import { Link, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/PageHeader';

// 403 page: the route exists but the signed-in user lacks its permission (PermissionGate). Title "No access".
export default function Forbidden({ permission }: { permission?: string }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <>
      <PageHeader title={t('error.forbidden')} subtitle={t('error.forbidden.detail', { path: pathname, permission: permission ?? '—' })} />
      <p>
        <Link to="/dash/stores">{t('error.goHome')}</Link>
      </p>
    </>
  );
}
